export default __webpack_public_path__ + "static/media/provesional_restoration_lower_12_2@2x.e3ba2be0.png";